import React, { Fragment } from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import Button from '@material-ui/core/Button';
import Camera from '@material-ui/icons/CameraAlt';
import DeleteIcon from '@material-ui/icons/Delete';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import TextField from '@material-ui/core/TextField';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

import GhaWhPoAwbException from '../../../models/GhaWhPoAwbException';

import pickupOrderRemote from '../../../api/pickupOrderRemote';

import whsOrderAwbReportStyles from './whsOrderAwbReport.module.css';
import commonStyles from '../../common/common.module.css';
import ExceptionTypes from '../../../models/ExceptionTypes';
import moment from 'moment';
import AwbPart from '../../../models/AwbPart';

const styles = (theme: Theme) =>

  createStyles({
    group: {
      marginLeft: '10px'
    },
    checkbox: {
      padding: '0 12px 0 12px'
    },
    camera: {
      color: '#fff',
      fontSize: '20px',
      marginBottom: '5px',
      backgroundColor: 'var(--primaryblue)',
      border: '1px solid var(--primaryblue)',
      borderRadius: '50%',
      padding: '10px',
      cursor: 'pointer',
      boxSizing: 'content-box',
    },
    flightPart: {
      width: '25%'
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gridColumnGap: '30px',
      gridRowGap: '10px'
    },
    deleteIcon: {
      color: 'white',
      fontSize: '20px'
    },
    textField: {
      width:'100%'
    },
    button: {
      marginBottom: '20px',
      marginTop: '10px',
      minWidth: '120px',
      marginRight: '12px',
      '&:last-child': {
        marginRight: '0'
      }
    },
    sizeIcon: {
      fontSize: '24px'
    },
    podHeader: {
      borderBottom: '1px solid lightgrey',
      paddingBottom: '10px',
      marginBottom: '10px'
    }
  });

interface WhsOrderAwbReportProps {
  classes: any;
  awbNumber: string;
  exceptions: GhaWhPoAwbException;
  show_on_pod?: ExceptionTypes;
  handleChange: (
    type: string,
    excOrPackData?: { index: number, value: boolean },
    event?: any,
    index?: number 
  ) => void;
  handleAttachmentDelete: (attachment: string) => void;
  handleAttachmentUpload: (event: any) => void;
  returnToDriverAwb: () => void;
  showOnPodChange?: (type: string, index: number) => void;
  selectAll?: () => void;
  selectValue?: boolean;
  saveExit: (type: string) => void;
  type: string;
  onlyRead?: boolean;
  userRole?: string;
};

const whsOrderAwbReport = (props: WhsOrderAwbReportProps) => {

  const { classes, awbNumber, exceptions } = props;

  const atachmentImages = props.exceptions.attachments.map((attachment: string) => {
    return (
      <div className={whsOrderAwbReportStyles.attachmentContainer}>
        <img src={pickupOrderRemote.constructAttachmentUrl(attachment)} className={whsOrderAwbReportStyles.attachmentImage} alt="img" />
        { !props.onlyRead &&
          <div onClick={() => props.handleAttachmentDelete(attachment)} className={whsOrderAwbReportStyles.deleteAttachment}><DeleteIcon className={ classes.deleteIcon } /></div>
        }
      </div>
    )
  });

  const partsNotDelivered = exceptions.parts.map((part: AwbPart, index: number) => {
    return (
    <div className={ whsOrderAwbReportStyles.notDeliveredWrapper }>
      <div className={ `${commonStyles.inputLabelWrapper} ${classes.flightPart}` }>
      <label className={ commonStyles.inputLabel }>Flight</label>
        { `${part.flight_no}/${moment(part.flight_date).format('DD-MMM-YY')}` }
      </div>
      <div className={ `${commonStyles.inputLabelWrapper} ${classes.flightPart}` }>
        <label className={ commonStyles.inputLabel }>Part PCS</label>
        { `${part.pieces} Pieces` }
      </div>
      <div className={ `${commonStyles.inputLabelWrapper}` }>
        <label className={ commonStyles.inputLabel }>PCS</label>
        <TextField
          value={ part.not_delivered_pieces || '' }
          variant="outlined"
          onChange={ (event) => {props.handleChange('pcs', undefined, event, index)} }
          className={ classes.inputField }
          InputLabelProps={{ shrink: true }}
          disabled={ props.onlyRead }
          fullWidth
        />
      </div>
      <div className={ `${commonStyles.inputLabelWrapper}` }>
        <label className={ commonStyles.inputLabel }>Weight</label>
        <TextField
          value={ part.not_delivered_weight || '' }
          variant="outlined"
          onChange={ (event) => {props.handleChange('weight', undefined, event,index)} }
          className={ classes.inputField }
          InputLabelProps={{ shrink: true }}
          disabled={ props.onlyRead }
          fullWidth
          type='number'
        />
      </div>
    </div>
    )
  })

  return (
    <div className={ whsOrderAwbReportStyles.mainWrapper }>
      <div className={ whsOrderAwbReportStyles.wrapperTitle }>
        { !props.onlyRead &&
          <div className={ whsOrderAwbReportStyles.headerTitle }>
            <span className={ whsOrderAwbReportStyles.awbNumber }>{ awbNumber }</span>
            <span>Report Exception</span>
          </div>
        }
        <div className={ `${ commonStyles.wrapper } ${ whsOrderAwbReportStyles.wrapper }` } >
          <h3 className={ commonStyles.header }>Kind of exception</h3>
          <FormGroup className={ classes.grid }>
            { exceptions.exception.map((exc: { id: number; name: string; selected: boolean; }, index: number) => {
              return <FormControlLabel
                  key={ index }
                  label={ exc.name }
                  control={
                    <Checkbox
                      checked={ exc.selected }
                      onChange={ () => props.handleChange('exception', { index, value: exc.selected }) } value={ '' + exc.id }
                      color="primary"
                      className={ classes.checkbox }
                      icon={<CheckBoxOutlineBlankIcon className={classes.sizeIcon} />} 
                      checkedIcon={<CheckBoxIcon className={classes.sizeIcon} />}
                      disabled={ props.onlyRead }
                    />
                  }
                  className={ classes.formControlLabel }
                />
            })}
          </FormGroup>
        </div>

        <div className={ `${ commonStyles.wrapper } ${ whsOrderAwbReportStyles.wrapper }` } >
          <h3 className={ commonStyles.header }>Kind of packaging</h3>
          <FormGroup className={ classes.grid }>
            { exceptions.packaging.map((pack: { id: number; name: string; selected: boolean; }, index: number) => {
              return <FormControlLabel
                  key={ index }
                  label={ pack.name }
                  control={
                    <Checkbox
                      checked={ pack.selected }
                      onChange={ () => props.handleChange('packaging', { index, value: pack.selected }) } value={ '' + pack.id }
                      color="primary"
                      className={ classes.checkbox }
                      icon={<CheckBoxOutlineBlankIcon className={classes.sizeIcon} />}
                      checkedIcon={<CheckBoxIcon className={classes.sizeIcon} />}
                      disabled={ props.onlyRead }
                    />
                  }
                  className={ classes.formControlLabel }
                />
            })}
          </FormGroup>
        </div>

        <div className={ `${ commonStyles.wrapper } ${ whsOrderAwbReportStyles.wrapper }` } >
          <h3 className={ commonStyles.header }>Contents Damaged</h3>
          <RadioGroup
            aria-label="position"
            name="position"
            value={ '' + exceptions.contents_damaged }
            onChange={ (event) => props.handleChange('contents_damaged', undefined, event) }
            row
            className={ whsOrderAwbReportStyles.radioGroupReport }
          >
            <FormControlLabel
              value="true"
              control={ <Radio color="primary" /> }
              label="Yes"
              disabled={ props.onlyRead }
            />
            <FormControlLabel
              value="false"
              control={ <Radio color="primary" /> }
              label="No"
              className={ classes.group }
              disabled={ props.onlyRead }
            />
            <FormControlLabel
              value="null"
              control={ <Radio color="primary" /> }
              label="Unknown"
              className={ classes.group }
              disabled={ props.onlyRead }
            />
          </RadioGroup>
        </div>
      </div>

      { props.type === 'po' && 
      
        <div className={`${commonStyles.wrapper} ${whsOrderAwbReportStyles.wrapper}`} >
          <h3 className={commonStyles.header}>Packages not delivered</h3>
          {partsNotDelivered}

        </div>

      }

      <div className={`${commonStyles.wrapper} ${whsOrderAwbReportStyles.wrapper}`} >
        <div className={`${whsOrderAwbReportStyles.headerContainer} ${whsOrderAwbReportStyles.headerContainerAlign}`}>
          <h3 className={commonStyles.header}>Attachments</h3>
          {!props.onlyRead && (
            <label htmlFor="fileUpload" className={`${whsOrderAwbReportStyles.uploadLabel} ${whsOrderAwbReportStyles.uploadLabelMargin}`}>
              <Camera className={classes.camera} />
            </label>
          )}
        </div>

        {!props.onlyRead && (
          <input
            id="fileUpload"
            type="file"
            name="attachment"
            className={whsOrderAwbReportStyles.fileUpload}
            onChange={props.handleAttachmentUpload}
          />
        )}

        {atachmentImages}
      </div>

      <div className={ `${ commonStyles.wrapper } ${ whsOrderAwbReportStyles.wrapper }` } >
        <h3 className={ commonStyles.header }>Remarks</h3>
        <TextField
          id="outlined-multiline-flexible"
          placeholder="-- Enter remarks"
          multiline
          rows="3"
          rowsMax="3"
          value={ exceptions.note || '' }
          onChange={ (event) => props.handleChange('note', undefined, event) }
          variant="outlined"
          className={ classes.textField }
          disabled={ props.onlyRead }
        />
      </div>

       { props.show_on_pod && !props.onlyRead  && 
        <div className={ `${ commonStyles.wrapper } ${ whsOrderAwbReportStyles.wrapper }` } >
          <h3 className={ commonStyles.header }>Show on Proof Of Delivery</h3>
          <div className={ classes.podHeader }>
            <FormControlLabel
              key={ 'all' }
              label={ "All" }
              control={
                <Checkbox
                  checked={ props.selectValue }
                  onChange={ () => props.selectAll && props.selectAll() }
                  color="primary"
                  className={ classes.checkbox }
                  icon={<CheckBoxOutlineBlankIcon className={ classes.sizeIcon } />} 
                  checkedIcon={<CheckBoxIcon className={ classes.sizeIcon } />}
                  disabled={ props.onlyRead }
                />
                }
              className={ classes.formControlLabel }
            />
          </div>
          <FormGroup className={ classes.grid }>
            { props.show_on_pod && props.show_on_pod.data.map((val:any, index: number) => {
              return <FormControlLabel
                      key={ index }
                      label={ val.label }
                      control={
                        <Checkbox
                          checked={ val.value }
                          onChange={ () => props.showOnPodChange && props.showOnPodChange(val.type, index) }
                          color="primary"
                          className={ classes.checkbox }
                          icon={<CheckBoxOutlineBlankIcon className={ classes.sizeIcon } />} 
                          checkedIcon={<CheckBoxIcon className={ classes.sizeIcon  } />}
                          disabled={ props.onlyRead }
                        />
                        }
                      className={ classes.formControlLabel }
                      />
            })}
          </FormGroup>
        </div> 
       }

      <div className={ whsOrderAwbReportStyles.buttonWrapper }>
        { props.type === 'do' && !props.onlyRead &&
          <Button
            color="primary" 
            variant="contained"
            onClick={ props.returnToDriverAwb }
            className={ classes.button } 
          >Return to Driver
          </Button>
        }
        { !props.onlyRead && 

            <Button
              color="primary" 
              variant="contained"
              onClick={ () => props.saveExit('save') }
              className={ classes.button }
            >Save and Exit
            </Button>
        }
        { props.userRole === 'whs' &&
            <Button 
              color="primary" 
              variant="contained"
              onClick={ () => props.saveExit('exit') }
              className={ classes.button }
            >Exit
            </Button>
        }
      </div>

    </div>
  );
};

export default withStyles(styles)(whsOrderAwbReport);